import React, { Component } from 'react'
import { Box } from 'reactjs-admin-lte'
import { Button, ButtonToolbar, FormGroup, Row, Col, FormControl, ControlLabel, DropdownButton, MenuItem } from 'react-bootstrap'
import FontAwesome from 'react-fontawesome'
import TyreStore from 'stores/TyreStore'
import DatePicker from 'component/element/DatePicker'
import WorkdocStore from 'stores/WorkdocStore'
import CKAutocomplete from 'component/element/CKAutocomplete'
import InputNumber from 'rc-input-number'
import RemarkRecordModal from 'component/element/RemarkRecordModal'
import IframeModal from 'component/element/IframeModal'
import ConfirmPopup from 'component/element/ConfirmPopup'

const NotificationSystem = require('react-notification-system')
const DEFAULT_ROW = 10
class TyreRetireDoc extends Component {
    constructor(props) {
       super(props)
      
       this.state = {
            loading:false,
            trNo:undefined,
            customerList:[],
            stockApproverList:[],
            doc:{tyre_retire_no:'',seq_no:'',status:'',request_by:'',response_by:'',description:'',added_date:'',amount:'',remark:'',trash_flag:'',added_by:''},
            itemlist:[],
            showRemark:false,
            showConfirm:false,
            msgConfirm:''
        }
    }
  
    componentDidMount() {
        this._notificationSystem = this.refs.notificationSystem
    }

    componentWillReceiveProps(newProps) {
        if (newProps.onShow&&this.props.onShow!==newProps.onShow){
            this.loadWorkdocAutocompleteOfficer()
            this.loadWorkdocAutocompleteStockApprover()
        }    
    }  

    getNumberFormat(value) {
        let _val = value===''||value===null||value===undefined||isNaN(value) ? 0 : value
        _val = parseFloat(_val)
        return _val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
    }

    setDocAmount() {
        let {itemlist} = this.state
        let _amount = 0
        itemlist.forEach((item,index)=>{
            let amount = (item.amount===''||item.amount===null||item.amount===undefined||isNaN(item.amount)?0:item.amount)
            _amount += amount*1
        })
        return _amount
    }

    newEmptyRow(number) {
        return new Array(number).fill(null).map((item,index) => {
            return {tyre_retire_item_id:'',seq:'',tyrecode:'',mileage:'',vehicle_id:'',tyre_size:'',start_used_date:'',total_retread:'',last_tread_depth:'',last_tread_date:'',retire_date:undefined,remark:'',brand:'',model:'',vehicle_registration_no:'',detail:''}
        })
    }
    
    loadNewDoc() {
        let {itemlist,doc,trNo} = this.state
        this.setState({loading:true})
        TyreStore.loadNewReportRetireDoc((result)=>{
            doc = Object.assign(doc,result.data.doc)
            trNo = doc.tyre_repair_no
            doc.tyre_retire_no = trNo
            itemlist = result.data.itemlist
            itemlist = this.newEmptyRow(DEFAULT_ROW) 
            this.setState({loading:false,doc:doc,itemlist:itemlist,trNo:trNo})
        })
    }

    loadData(trNo) {
        let {itemlist,doc} = this.state
        this.setState({loading:true,trNo:trNo})
        TyreStore.loadReportRetireDoc(trNo,(result)=>{
            doc = Object.assign(doc,result.data.doc)
            doc.amount = this.setDocAmount()
            itemlist = result.data.itemlist
            if (itemlist.length===0) {
                itemlist = this.newEmptyRow(DEFAULT_ROW)
            } else {
                if (itemlist.length<DEFAULT_ROW) {
                    itemlist = itemlist.concat(this.newEmptyRow(DEFAULT_ROW-itemlist.length))
                }
            }    
            this.setState({loading:false,doc:doc,itemlist:itemlist})
        })
    }
    
    loadWorkdocAutocompleteOfficer() {
        let officer = []
        WorkdocStore.loadWorkdocAutocompleteOfficer((result)=>{
            result.data.forEach(element => {
                officer.push({
                    id: element.Value,
                    label: element.Name,
                    emp_id: element.employee_id
                })
            })
          this.setState({customerList:officer})
        })  
    }  
    
    loadWorkdocAutocompleteStockApprover() {
        let approver = []
        WorkdocStore.loadWorkdocAutocompleteStockApprover((result)=>{
            result.data.forEach(element => {
                approver.push({
                    id: element.Value,
                    label: element.Name,
                    emp_id: element.employee_id
                })
            })
          this.setState({stockApproverList:approver})
        })  
    }

    onRowAdd(number) {
        let {itemlist} = this.state
        itemlist = itemlist.concat(this.newEmptyRow(number))
        this.setState({itemlist:itemlist})
    }

    onSaveClick() {
        this.saveTRDoc()
    }

    saveTRDoc() {
        let {doc,itemlist} = this.state
        let postData = {doc:doc,itemlist:itemlist}
        this.setState({loading:true})
        TyreStore.saveTyreRetireDoc(this.state.trNo,postData,(result)=>{
            if (result.status==='OK') {
                doc.seq_no = result.seq_no
                this.setState({loading:false,doc:doc})
                this._notificationSystem.addNotification({
                    title:'แจ้งเตือน',
                    message:'ทำการบันทึกรายการใบยางหมดอายุเรียบร้อย',
                    level:'info',
                    position:'tc'
                })
            }
        },()=>{
            this.setState({loading:false})
            this._notificationSystem.addNotification({
                title:'แจ้งเตือน',
                message:'ทำการบันทึกรายการล้มเหลว',
                level:'error',
                position:'tc'
            })
        })
    }

    onCloseClick() {
        if (this.props.onCloseClick!==undefined)
            this.props.onCloseClick()
    }

    onTextChange(field,e) {
        let {doc} = this.state
        doc[field] = e.target.value
        this.setState({doc:doc})
    }

    onTextSelect(field,e) {
        let {doc} = this.state
        doc[field] = e
        this.setState({doc:doc})
        // if (field==='request_by')
        //     this.refs._response_by.onFocus()
    }

    onRowTextChange(index,field,e) {
        let {itemlist,doc} = this.state
        itemlist[index][field] = (field==='tyre_size'||field==='total_retread'||field==='last_tread_depth'||field==='mileage'?e:e.target.value)
        doc.amount = this.setDocAmount()
        this.setState({itemlist:itemlist,doc:doc})
    }

    onDateChange(index,field,e) {
        let {itemlist} = this.state
        itemlist[index][field] = e
        this.setState({itemlist:itemlist})
    }

    onDeleteRowClick(index) {
        let {itemlist,doc} = this.state
        itemlist.splice(index,1) 
        doc.amount = this.setDocAmount()
        this.setState({itemlist:itemlist,doc:doc})
        this.saveTRDoc()
    }

    onDropdownSelect(e) {
        if (e===2) {
            this.setState({showConfirm:true,msgConfirm:'ยืนยันการทำรายการอนุมัติใบยางหมดอายุหรือไม่ ?'})
        } else if (e===3) {
            this.setState({showConfirm:true,msgConfirm:'ยืนยันการทำรายการยกเลิกอนุมัติใบยางหมดอายุหรือไม่ ?'})
        } else if (e===4) {
            this.setState({showRemark:true})
        }
    }

    onPrintClick(){
        let {trNo} = this.state
        let url = './pdf/v2?startPage=PrintTyreRetireDoc&trNo='+trNo
        if (process.env.NODE_ENV === "development") {
            url = '?startPage=PrintTyreRetireDoc&trNo='+trNo
        }
        this.refs.iframe.loadUrl(url)
    }

    onRemarkDeleteRecordClick() {
        this.setState({loading:true})
        TyreStore.delTyreRetireDoc(this.state.trNo,(result)=>{
            if (result.status==='OK') {
                this._notificationSystem.addNotification({
                    title:'แจ้งเตือน',
                    message:'ทำการลบรายการใบยางหมดอายุเลขที่ '+this.state.trNo+' เรียบร้อย',
                    level:'info',
                    position:'tc'
                })
                this.setState({loading:false,showRemark:false})
                this.onCloseClick()
            }
        },()=>{
            this._notificationSystem.addNotification({
                title:'แจ้งเตือน',
                message:'ทำการลบรายการล้มเหลว',
                level:'error',
                position:'tc'
            })
            this.setState({loading:false,showRemark:false})
        })
    }

    onConfirmClick() {
        let status = ''
        if (this.state.msgConfirm==='ยืนยันการทำรายการอนุมัติใบยางหมดอายุหรือไม่ ?') {
            status = '1'
        } else if (this.state.msgConfirm==='ยืนยันการทำรายการยกเลิกอนุมัติใบยางหมดอายุหรือไม่ ?') {
            status = '0'
        }
        let postData = {tyre_retire_no:this.state.trNo,status:status}
        TyreStore.updateTyreRetireDoc(status,postData,(result)=>{
            if (result.status==='OK') {
                let _msg = ''
                if (status==='1')
                    _msg = 'อนุมัติ'
                else
                    _msg = 'ยกเลิก'
                
                this._notificationSystem.addNotification({
                    title:'แจ้งเตือน',
                    message:'ทำการ'+_msg+'ใบยางหมดอายุเลขที่ '+this.state.trNo+' เรียบร้อย',
                    level:'info',
                    position:'tc'
                })
                this.setState({showConfirm:false,msgConfirm:''})
            }
        },()=>{
            this._notificationSystem.addNotification({
                title:'แจ้งเตือน',
                message:'ทำรายการล้มเหลว',
                level:'error',
                position:'tc'
            })
            this.setState({showConfirm:false,msgConfirm:''})
        })
    }

    renderHeaderRow() {
        return (
            <div>           
                <Row>
                    <Col md={1}>
                        <FormGroup>
                            <ControlLabel>เลขที่เอกสาร</ControlLabel>
                        </FormGroup>
                    </Col>
                    <Col md={5}>
                        <FormGroup>
                            <FormControl onChange={()=>{}} type="text" placeholder="<เลขที่ถูกสร้างอัตโนมัติ>" className="input-dark" />
                        </FormGroup>
                    </Col>
                    <Col md={1}>
                        <FormGroup>
                            <ControlLabel>วันที่</ControlLabel>
                        </FormGroup>
                    </Col>
                    <Col md={5}>
                        <FormGroup>
                            <FormControl onChange={()=>{}} type="text" placeholder="" className="input-dark" value={this.state.doc.added_date} />
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col md={1}>
                        <FormGroup
                            controlId={null}
                            validationState={null}
                        >
                            <ControlLabel>ผู้ขอเบิก</ControlLabel>
                        </FormGroup>
                    </Col>
                    <Col md={5}>
                        <FormGroup
                            controlId={null}
                            validationState={null}
                        >
                            <CKAutocomplete
                                top={'-34px'}
                                items={this.state.customerList}
                                value={this.state.doc.request_by}
                                onChange={this.onTextChange.bind(this, 'request_by')}
                                onSelect={this.onTextSelect.bind(this, 'request_by')}
                            />
                        </FormGroup>
                    </Col>
                    <Col md={1}>
                        <FormGroup
                            controlId={null}
                            validationState={null}
                        >
                            <ControlLabel>ชื่อผู้อนุมัติ</ControlLabel>
                        </FormGroup>
                    </Col>
                    <Col md={5}>
                        <FormGroup
                            controlId={null}
                            validationState={null}
                        >
                            <CKAutocomplete
                                top={'-34px'}
                                items={this.state.customerList}
                                value={this.state.doc.response_by}
                                onChange={this.onTextChange.bind(this, 'response_by')}
                                onSelect={this.onTextSelect.bind(this, 'response_by')}
                                // ref='_response_by'
                            />
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col md={1}>
                        <FormGroup>
                            <ControlLabel>คำอธิบาย</ControlLabel>
                        </FormGroup>
                    </Col>
                    <Col md={3}>
                        <FormGroup>
                            <FormControl value={this.state.doc.description} onChange={this.onTextChange.bind(this, 'description')} />
                        </FormGroup>
                    </Col>
                </Row>    
            </div>
        )          
    }
    
    renderRowData() {
        let {itemlist} = this.state
        if (itemlist.length===0) {
            return(<tr><td colSpan={13}>ไม่พบข้อมูล</td></tr>)
        } else {
            return(
                itemlist.map((item,index)=>
                    <tr key={index}>
                        <td className='text-center'>{index+1}</td>
                        <td className='text-center'>
                            <FormControl className='text-center' onChange={this.onRowTextChange.bind(this,index,'tyrecode')} value={item.tyrecode} />
                        </td>
                        <td className='text-center'>
                            <FormControl className='text-center' onChange={this.onRowTextChange.bind(this,index,'brand')} value={item.brand===null?'':item.brand} />
                        </td>
                        <td className='text-center'>
                            <FormControl className='text-center' onChange={this.onRowTextChange.bind(this,index,'model')} value={item.model===null?'':item.model} />
                        </td>
                        <td className='text-center'>
                            <InputNumber
                                className='input-number-format-form-control text-center'
                                value={item.tyre_size} 
                                onChange={this.onRowTextChange.bind(this,index,'tyre_size')}
                                formatter={value =>
                                    `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                                }
                            />
                        </td>
                        <td className='text-center'>
                            <DatePicker 
                                style={{display:'inline-block'}}
                                showIcon={true}
                                showFooter={true}
                                popPlacement='bottom'
                                buddhistEra
                                value={item.start_used_date}
                                onChange={this.onDateChange.bind(this,index,'start_used_date')}
                                maxWidth={'100%'}
                            />
                        </td>
                        <td className='text-center'>
                            <InputNumber
                                className='input-number-format-form-control text-center'
                                value={item.total_retread} 
                                onChange={this.onRowTextChange.bind(this,index,'total_retread')}
                                formatter={value =>
                                    `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                                }
                            />
                        </td>
                        <td className='text-center'>
                            <InputNumber
                                className='input-number-format-form-control text-center'
                                value={item.last_tread_depth} 
                                onChange={this.onRowTextChange.bind(this,index,'last_tread_depth')}
                                formatter={value =>
                                    `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                                }
                            />
                        </td>
                        <td className='text-center'>
                            <DatePicker 
                                style={{display:'inline-block'}}
                                showIcon={true}
                                showFooter={true}
                                popPlacement='bottom'
                                buddhistEra
                                value={item.last_tread_date}
                                onChange={this.onDateChange.bind(this,index,'last_tread_date')}
                                maxWidth={'100%'}
                            />
                        </td>
                        <td className='text-center'>
                            <InputNumber
                                className='input-number-format-form-control text-center'
                                value={item.mileage} 
                                onChange={this.onRowTextChange.bind(this,index,'mileage')}
                                formatter={value =>
                                    `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                                }
                            />
                        </td>
                        <td className='text-center'>
                            <FormControl className='text-center' onChange={this.onRowTextChange.bind(this,index,'vehicle_registration_no')} value={item.vehicle_registration_no} />
                        </td>
                        <td className='text-center'>
                            <DatePicker 
                                style={{display:'inline-block'}}
                                showIcon={true}
                                showFooter={true}
                                popPlacement='bottom'
                                buddhistEra
                                value={item.retire_date}
                                onChange={this.onDateChange.bind(this,index,'retire_date')}
                                maxWidth={'100%'}
                            />
                        </td>
                        <td className='text-center'>
                            <Button bsStyle={'danger'} onClick={this.onDeleteRowClick.bind(this,index)}><FontAwesome name='trash'/></Button>
                        </td>
                    </tr>
                )
            )
        }
    }

    renderTable() {
        let {doc} = this.state
        return(
            <div className='table-responsive'>
                <table className="table table-hover table-bordered-solid" style={{minWidth:'1800px',marginBottom:'0'}}>
                    <thead>
                        <tr>
                            <th style={{width:'50px'}} className='text-center'>ลำดับ</th>
                            <th style={{width:'100px'}} className='text-center'>หมายเลขยาง</th>
                            <th style={{width:'100px'}} className='text-center'>ยี่ห้อ</th>
                            <th style={{width:'100px'}} className='text-center'>รุ่น</th>
                            <th style={{width:'80px'}} className='text-center'>ขนาดยาง</th>
                            <th style={{width:'130px',minWidth:'130px'}} className='text-center'>วันที่เริ่มใช้ยาง</th>
                            <th style={{width:'80px'}} className='text-center'>จำนวนครั้ง<br/>หล่อดอก</th>
                            <th style={{width:'80px'}} className='text-center'>ความลึกดอกยาง<br/>วัดครั้งสุดท้าย<br/>(ม.ม)</th>
                            <th style={{width:'130px',minWidth:'130px'}} className='text-center'>วัดดอกยางเมื่อวันที่</th>
                            <th style={{width:'90px'}} className='text-center'>จำนวน ก.ม.<br/>ที่วิ่งได้</th>
                            <th style={{width:'100px'}} className='text-center'>ทะเบียนรถ<br/>ใช้ยางครั้งสุดท้าย</th>
                            <th style={{width:'130px',minWidth:'130px'}} className='text-center'>ถอดไว้ที่คลัง<br/>เมื่อวันที่</th>
                            <th style={{width:'30px'}} className='text-center'>ลบ</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.renderRowData()}
                    </tbody>
                    <tfoot>
                        <tr>            
                            <th colSpan={11} className='text-right'>รวมยางที่หมดสภาพ</th>
                            <th className='text-right'>{this.getNumberFormat(doc.amount)}</th>
                            <th className='text-right'></th>
                        </tr>
                    </tfoot>    
                </table>
            </div>
        )    
    }

    renderNewItemButton() {
        return(
            <Row style={{marginTop:'10px'}}>
                <Col md={12}>
                    <ButtonToolbar>
                        <Button className='bg-olive' onClick={this.onRowAdd.bind(this,1)}><FontAwesome name='plus'/>&nbsp;เพิ่มรายการ</Button>
                        <Button className='bg-olive' onClick={this.onRowAdd.bind(this,10)}><FontAwesome name='plus'/>&nbsp;เพิ่ม 10 รายการ</Button>
                    </ButtonToolbar>        
                </Col>
            </Row>
        )
    }

    renderRemark() {
        return (
            <Row style={{marginTop:'10px'}}>
                <Col lg={3} md={3} sm={6}>
                    <FormGroup
                        controlId={null}
                        validationState={null}
                    >
                        <ControlLabel>หมายเหตุ</ControlLabel>
                        <FormControl value={this.state.doc.remark===null?'':this.state.doc.remark} componentClass="textarea" style={{height:'150px'}} onChange={this.onTextChange.bind(this,'remark')} />            
                    </FormGroup>
                </Col>  
            </Row>
        )
    }

    render() {
        let {loading,trNo,doc} = this.state
        return(
            <div>
                <Box loading={loading}>
                    <Box.Header className='text-center'>
                        <Box.Title>
                            {'ใบยางหมดอายุเลขที่ '+trNo}
                        </Box.Title>
                        <Box.Tools className='pull-right'>
                            <Button bsClass='bg-maroon btn' onClick={this.onPrintClick.bind(this)}><FontAwesome name='print' />&nbsp;พิมพ์เอกสาร</Button>&nbsp;
                            {doc.seq_no!==''?
                            <DropdownButton
                                bsStyle={'primary'}
                                title={'เปลี่ยนสถานะ'}
                                key={0}
                                id={'dropdown-invoice-status-menu-button'}
                                onSelect={this.onDropdownSelect.bind(this)}
                            >	      
                                <MenuItem eventKey="2"><FontAwesome name='thumbs-up'/> อนุมัติ</MenuItem>
                                <MenuItem eventKey="3"><FontAwesome name='ban'/> ยกเลิกอนุมัติ</MenuItem>
                                <MenuItem divider />
                                <MenuItem eventKey="4"><FontAwesome name='trash'/> ลบเอกสาร</MenuItem>
                            </DropdownButton> 
                            :''}
                        </Box.Tools>
                    </Box.Header>
                    <Box.Body>
                        {this.renderHeaderRow()}
                        {this.renderTable()}
                        {this.renderNewItemButton()}
                        {this.renderRemark()}
                    </Box.Body>
                    <Box.Footer>
                        <ButtonToolbar className='pull-right'>
                            <Button bsStyle='primary' onClick={this.onSaveClick.bind(this)}><FontAwesome name='save' />&nbsp;บันทึก</Button>
                            <Button onClick={this.onCloseClick.bind(this)}><FontAwesome name='close' />&nbsp;ปิดเอกสาร</Button>
                        </ButtonToolbar>
                    </Box.Footer>
                </Box>
                <NotificationSystem ref="notificationSystem" />
                <IframeModal ref='iframe'  title={'พิมพ์เอกสาร'} />
                <RemarkRecordModal
                    show={this.state.showRemark}
                    docTitle='ลบใบยางหมดอายุ'
                    docName='tyrerepair'
                    docNo={trNo}
                    docTag=''
                    onModalClose={()=>{this.setState({showRemark:false})}}
                    onSuccess={this.onRemarkDeleteRecordClick.bind(this)}
                />
                <ConfirmPopup
                    show={this.state.showConfirm}
                    message={this.state.msgConfirm}
                    onConfirm={this.onConfirmClick.bind(this)}
                    onHide={()=>{this.setState({showConfirm:false,msgConfirm:''})}}
                />
            </div>
        )
    }
}

TyreRetireDoc.defaultProps = {
        
}
      
export default TyreRetireDoc;        


// WEBPACK FOOTER //
// ./src/view/tyre/TyreRetireDoc.js